export default __webpack_public_path__ + "static/google-reviews1-e06f8c2b86ed839da670d273487bf35a.svg";